import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updatePassword,
  deleteUser,
  confirmPasswordReset,
  sendPasswordResetEmail,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from 'firebase/auth';

import { USER_TYPES } from '../Constant/Enums';

import { prepareFirebaseAuth, waitForFirebaseAuth } from './firebaseClients';

const mapFirebaseUser = user => ({
  uid: user.uid,
  name: user.displayName,
  email: user.email,
  emailVerified: user.emailVerified,
  phoneNumber: user.phoneNumber,
  photoURL: user.photoURL,
  createdAt: user.metadata.creationTime,
});

const FireBase = {
  createProfessional: async (email, password) => {
    try {
      const auth = await prepareFirebaseAuth(USER_TYPES.PROFESSIONAL);
      const response = await createUserWithEmailAndPassword(auth, email, password);

      return {
        data: mapFirebaseUser(response.user),
        errors: null,
      };
    } catch (error) {
      return { data: null, errors: error.code };
    }
  },
  signIn: async (email, password) => {
    try {
      const auth = await prepareFirebaseAuth(USER_TYPES.PROFESSIONAL);
      const response = await signInWithEmailAndPassword(auth, email, password);

      return {
        data: mapFirebaseUser(response.user),
        errors: null,
      };
    } catch (error) {
      return { data: null, errors: error.code };
    }
  },
  deleteProfessional: async () => {
    const auth = await waitForFirebaseAuth(USER_TYPES.PROFESSIONAL);
    if (!auth?.currentUser) return Promise.resolve();
    return deleteUser(auth.currentUser);
  },
  updatePassword: async (oldPassword, newPassword) => {
    const auth = await waitForFirebaseAuth(USER_TYPES.PROFESSIONAL);
    const user = auth.currentUser;

    if (!user) {
      throw new Error('No authenticated professional user');
    }

    const credentials = EmailAuthProvider.credential(user.email, oldPassword);
    await reauthenticateWithCredential(user, credentials);
    return updatePassword(user, newPassword);
  },

  sendPasswordResetEmail: async email => {
    const auth = await prepareFirebaseAuth(USER_TYPES.PROFESSIONAL);
    return sendPasswordResetEmail(auth, email);
  },
  confirmPasswordReset: async (oobCode, newPassword) => {
    const auth = await prepareFirebaseAuth(USER_TYPES.PROFESSIONAL);
    return confirmPasswordReset(auth, oobCode, newPassword);
  },
};
export default FireBase;
